var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          { staticClass: "mr-auto" },
          [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.refresh } },
              [_c("i", { staticClass: "fas fa-sync-alt" })]
            ),
            _vm._v(" "),
            _vm._t("buttons"),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "align-self-end" },
          [
            _c("input-debounced", {
              staticClass: "search-bar w-300 mb-2",
              attrs: {
                clearable: true,
                autofocus: true,
                placeholder: "Search",
              },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("base-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.isRefreshing,
            expression: "isRefreshing",
          },
        ],
        ref: "baseTable",
        attrs: {
          "base-url": _vm.urlWithFilters,
          "current-page": _vm.currentPage,
          "element-loading-spinner": "el-icon-loading",
        },
        on: { "load-success": _vm.onLoadSuccess, refresh: _vm.onRefresh },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function () {
              return [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.items, stripe: "" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "model.id", label: "Id", width: "70" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.type_text",
                        label: "Type",
                        width: "170",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.name",
                        label: "Name",
                        width: "240",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.status_text",
                        label: "Status",
                        width: "85",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            row: {
                              model: { status, status_text },
                            },
                          }) {
                            return [
                              _c("status-column", {
                                attrs: { value: status, text: status_text },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.input_file",
                        label: "Input File",
                        "min-width": "300",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.report",
                        label: "Report",
                        width: "80",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: !_vm.isReportAvailable(row),
                                    type: "text",
                                    size: "small",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDetails(row)
                                    },
                                  },
                                },
                                [_vm._v("Details")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.log_file",
                        label: "Import Log",
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            row: {
                              model: { log_file },
                              logFileUrl,
                            },
                          }) {
                            return [
                              logFileUrl
                                ? _c("a", { attrs: { href: logFileUrl } }, [
                                    _vm._v(_vm._s(log_file)),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.user.full_name",
                        label: "User",
                        width: "120",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "model.created_at",
                        formatter: _vm.formatDate,
                        label: "Created",
                        width: "130",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "Actions", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("actions-column", {
                                attrs: { row: row },
                                on: { revert: _vm.onRevert },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "text-right",
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
        },
        on: {
          "update:currentPage": function ($event) {
            _vm.currentPage = $event
          },
          "update:current-page": function ($event) {
            _vm.currentPage = $event
          },
        },
      }),
      _vm._v(" "),
      _c("report-viewer", { ref: "reportViewer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }